// TODO enable eslint
/* eslint-disable no-param-reassign */
import omit from "lodash/omit"
import uuid4 from "uuid/v4"
import moment from "moment"
import { Model, Schema } from "src/engine/modules/model/classes"
import { DEFAULT_PAGE_HEIGHT } from "src/containers/Calendar/constants"

export const denormalizeEvent = data => {
  /* remove sec and msec from date for back */
  if (data.endDateTime) {
    data.endDateTime = moment(data.endDateTime)
      .startOf(`minute`)
      .valueOf()
  }
  if (data.startDateTime) {
    data.startDateTime = moment(data.startDateTime)
      .startOf(`minute`)
      .valueOf()
  }
  return omit(data, [`id`])
}

export const normalizeCalendarEvents = data => {
  const extracted = data.reduce((events, item) => {
    const itemEvents = item.items.map(event => {
      const virtualUuid = event.event ? event.event.uuid : uuid4()
      event.virtualId = `${event.rowId}__${virtualUuid}`
      return event
    })
    return events.concat(itemEvents)
  }, [])
  // singleExtracted - array for events with eventsStack=false
  const singleExtracted = extracted.filter(item => !item.eventsStack)

  return singleExtracted.length > 0 ? singleExtracted : extracted
}

export const mergeCalendarEvents = (nextData, currentData, action) => {
  const isFirstPageLoad =
    action.query.offset === 0 && action.query.limit === DEFAULT_PAGE_HEIGHT
  const finalData = isFirstPageLoad ? nextData : currentData.concat(nextData)

  return finalData
}
const entityName = `events`

export default new Model({
  name: entityName,
  getRestUrn: (method, id) => (id ? `/events/${id}` : `events`),
  primaryKey: `uuid`,
  denormalize: denormalizeEvent,
  schema: new Schema({
    startDateTime: new Schema.types.DateTime(`ms`),
    endDateTime: new Schema.types.DateTime(`ms`),
  }),
})
